/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Edit_Confirm_ActionInputs */

const es_chat_edit_confirm_action = /** @type {(inputs: Chat_Edit_Confirm_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar y regenerar`)
};

const en_chat_edit_confirm_action = /** @type {(inputs: Chat_Edit_Confirm_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit and regenerate`)
};

/**
* | output |
* | --- |
* | "Edit and regenerate" |
*
* @param {Chat_Edit_Confirm_ActionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_edit_confirm_action = /** @type {((inputs?: Chat_Edit_Confirm_ActionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Edit_Confirm_ActionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_edit_confirm_action(inputs)
	return en_chat_edit_confirm_action(inputs)
});
export { chat_edit_confirm_action as "chat.edit.confirm_action" }